import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./Register.css";
import registerImage from "./assets/csatlakozz.jpg";

const Register = () => {
  const location = useLocation();

  // Detect membership page
  const hideSecondButton = location.pathname === "/membership";

  const [form, setForm] = useState({
    lastName: "",
    firstName: "",
    email: "",
  });

  const isEmailValid = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValid =
    form.lastName.trim() !== "" &&
    form.firstName.trim() !== "" &&
    isEmailValid(form.email);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section className="register-section">
      <div className="register-container">

        <h2 className="register-title">Hogyan csatlakozhatsz?</h2>
        <p className="register-subtitle">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididun.
        </p>

        {/* Background layers */}
        <div className="register-background">
          <div className="register-bg-top"></div>
          <div className="register-bg-bottom"></div>
        </div>

        <div className="register-card-group">

          {/* Left side — form */}
          <div className="register-card">
            <form className="register-form" onSubmit={(e) => e.preventDefault()}>

              <div className="field-row">
                <div className="text-field">
                  <label>
                    Vezetéknév <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={form.lastName}
                    onChange={handleChange}
                    required
                    placeholder="Petőfi"
                  />
                </div>

                <div className="text-field">
                  <label>
                    Keresztnév <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={form.firstName}
                    onChange={handleChange}
                    required
                    placeholder="Sándor"
                  />
                </div>
              </div>

              <div className="field-group">
                <label>
                  Email cím <span className="required">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="petofisandor@email.com"
                />
              </div>

              <div className="field-group">
                <label>Telefonszám</label>
                <input type="tel" placeholder="+36..." />
              </div>

              {/* BUTTON GROUP */}
              <div className={`button-group ${hideSecondButton ? "single-button" : ""}`}>

                {/* Primary button */}
                <button
                  className={`btn-primary ${!isValid ? "disabled" : ""}`}
                  disabled={!isValid}
                >
                  Csatlakozz tagként ingyenesen
                </button>

                {/* SECONDARY BUTTON */}
                {hideSecondButton ? (
                  /* Ghost button to preserve layout width */
                  <a className="btn-secondary link-button ghost-button">Olvass többet a tagságról</a>
                ) : (
                  <a href="/membership" className="btn-secondary link-button">
                    Olvass többet a tagságról
                  </a>
                )}
              </div>
            </form>
          </div>

          {/* Right side image */}
          <div className="register-image">
            <img src={registerImage} alt="Regisztráció illusztráció" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Register;
